import {registerTileSchema} from '#core/application/schema-registry.js';

import RUNNER_INFO from './runner-info.palette-schema.yaml';

registerTileSchema(RUNNER_INFO);

export function generateRunnerInfo(TILE) {
    const RUNNER_CONTAINER_TEXT = {
        overflowWrap: 'break-word',
        ...TILE.RUNNER_CONTAINER_TEXT,
    };
    const COMPACT_TRICAST_RUNNER_TEXT = {
        ...TILE.COMPACT_TRICAST_RUNNER_TEXT,
    };

    return {
        namesContainer: {
            style: {
                padding: 0,
            },
        },
        selectionButtonContainer: {
            style: {
                _mobile_margin: '0 8px 0 0',
            },
        },
        runnerName: {
            style: {
                ...TILE.RUNNER_NAME_TEXT,
            },
        },
        cloth: {
            style: {
                ...TILE.RUNNER_CLOTH_TEXT,
            },
        },
        drawNumber: {
            style: {
                ...TILE.RUNNER_DRAW_NUMBER_TEXT,
            },
        },
        trainerAndJockeyNames: {
            style: {
                ...TILE.RUNNER_TRAINER_AND_JOCKEY_NAMES_TEXT,
            },
        },
        formContainer: {
            style: RUNNER_CONTAINER_TEXT,
        },
        runnerAgeAndJockeyWeightContainer: {
            style: RUNNER_CONTAINER_TEXT,
        },
        previousOddsContainer: {
            container: {
                _mobile_padding: '0 8px 4px 0',
            },
            style: {
                _mobile_textAlign: 'right',
                ...RUNNER_CONTAINER_TEXT,
            },
        },
        castMarketCompactRunnerNumber: {
            style: COMPACT_TRICAST_RUNNER_TEXT,
        },
        castMarketCompactRunnerName: {
            style: COMPACT_TRICAST_RUNNER_TEXT,
        },
    };
}
